// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Above SlidePanel (backdrop 1054, panel 1055) so the calendar is not hidden behind it. */
.leads-datepicker-popper {
  z-index: 2000 !important;
}

.leads-datepicker-wrap {
  position: relative;
  width: 100%;
}

.leads-datepicker-wrap .react-datepicker-wrapper {
  width: 100%;
  display: block;
}

.leads-datepicker-input {
  height: 36px;
  font-size: 12.5px;
  border-radius: 8px;
  /* Room for react-datepicker's own clear "x" (when a date is selected)
     plus our calendar icon further right, without the two overlapping. */
  padding-right: 46px;
  width: 100%;
  cursor: pointer;
}

/* react-datepicker's built-in clear button sits ~8px from the input's right
   edge by default — nudged left so it lands in the padding-right gutter
   above instead of the calendar icon's own slot. */
.leads-datepicker-wrap .react-datepicker__close-icon {
  right: 26px;
}

.leads-datepicker-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6B7280;
  cursor: pointer;
  pointer-events: auto;
}

.leads-datepicker-wrap:has(.leads-datepicker-input:disabled) .leads-datepicker-icon {
  color: #C4C9D1;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Leads/LeadDatePicker.css"],"names":[],"mappings":"AAAA,0FAA0F;AAC1F;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB;yEACuE;EACvE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;;mDAEmD;AACnD;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":["/* Above SlidePanel (backdrop 1054, panel 1055) so the calendar is not hidden behind it. */\n.leads-datepicker-popper {\n  z-index: 2000 !important;\n}\n\n.leads-datepicker-wrap {\n  position: relative;\n  width: 100%;\n}\n\n.leads-datepicker-wrap .react-datepicker-wrapper {\n  width: 100%;\n  display: block;\n}\n\n.leads-datepicker-input {\n  height: 36px;\n  font-size: 12.5px;\n  border-radius: 8px;\n  /* Room for react-datepicker's own clear \"x\" (when a date is selected)\n     plus our calendar icon further right, without the two overlapping. */\n  padding-right: 46px;\n  width: 100%;\n  cursor: pointer;\n}\n\n/* react-datepicker's built-in clear button sits ~8px from the input's right\n   edge by default — nudged left so it lands in the padding-right gutter\n   above instead of the calendar icon's own slot. */\n.leads-datepicker-wrap .react-datepicker__close-icon {\n  right: 26px;\n}\n\n.leads-datepicker-icon {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6B7280;\n  cursor: pointer;\n  pointer-events: auto;\n}\n\n.leads-datepicker-wrap:has(.leads-datepicker-input:disabled) .leads-datepicker-icon {\n  color: #C4C9D1;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
